import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BulkAction } from '../../models/bulk-action';
import { ModalDirective } from 'ngx-bootstrap';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { Constants } from '../../../shared/constants';
import { Page } from '../../../shared/models/page';
import { OrderedSet } from 'immutable';
import { DateUtil } from '../../../shared/utils/date.util';
import { EventListStore } from '../../service/event-list.store';
import { LogService } from '../../../shared/log/log.service';
import { PaymentStore } from '../../service/payment.store';
import { Payment } from '../../models/payment';
import { PaymentType } from '../../models/payment-type';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { ConfirmationModalConfig } from '../../../shared/confirmation-modal/confirmation-modal-config';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStatus } from '../../models/payment-status.enum';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { EventVendorSummary } from '../../models/event-vendor-summary';
import { Party } from '../../models/party';
import { isNullOrUndefined } from 'util';
import { BulkActionResponse } from '../../models/bulk-action-response';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'pioneer-bulk-action-popup',
  templateUrl: './bulk-action-popup.component.html',
  styleUrls: ['./bulk-action-popup.component.css']
})
export class BulkActionPopupComponent implements OnInit {

  @ViewChild(ConfirmationModalComponent)
  confirmationModal: ConfirmationModalComponent;

  @Output()
  refreshEvents = new EventEmitter<any>();

  @ViewChild(ModalDirective)
  bulkActionModal: ModalDirective;

  bulkAction: BulkAction = BulkAction.PAYMENT_REQUEST;

  eventVendorSummaryList: EventVendorSummary[];

  noEventsFound: boolean;

  eventCountForTranslate: Object;

  selectedVendors: EventVendorSummary[] = [];

  allEventsChecked: boolean;

  eventsProcessed: number;

  confirmationModalConfig = new ConfirmationModalConfig();



  config = {
    backdrop: 'static',
    keyboard: false
  };

  bulkActionInfo: string;
  bulkActionInProcess = false;

  constructor(private eventListStore: EventListStore,
              private logService: LogService,
              private paymentStore: PaymentStore,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService,
              private environment: EnvironmentConfiguration,
              private decimalPipe: DecimalPipe) { }

  ngOnInit() {
  }

  public get BulkAction() {
    return BulkAction;
  }

  open(action: BulkAction): void {
    this.bulkActionInProcess = false;
    this.eventsProcessed = 0;
    this.bulkAction = action;

    // Load and filter events
    this.eventListStore.loadBulkActionEvents(0, this.environment.events.maxEvents, OrderedSet([])).take(1)
      .subscribe((eventPage: Page<OnyxSummaryEvent>) => {

        this.eventVendorSummaryList = [];

        switch ( this.bulkAction ) {
          case BulkAction.PAYMENT_REQUEST:
            eventPage.content.filter(event =>
              !isNullOrUndefined(event.eventVendors) && this.hasEventFinished(event))
              .map(event => {
                event.eventVendors.filter(vendor => !vendor.subscriber
                  && vendor.paymentSummary
                  && vendor.paymentSummary.dueAmount
                  && Number(vendor.paymentSummary.dueAmount) > 0)
                  .map(vendor => {
                    if ( !isNullOrUndefined(vendor.contact) && !isNullOrUndefined(vendor.contact.email)
                    && vendor.contact.email.length > 1 ) {
                      this.addEventVendor(event, vendor);
                    }
                  });
              });
            break;
          case BulkAction.PAID_DIRECT:
            eventPage.content.filter(event =>
              !isNullOrUndefined(event.eventVendors) && this.hasEventFinished(event))
              .map(event => {
                event.eventVendors.filter(vendor => !vendor.subscriber
                  && vendor.paymentSummary && Number(vendor.paymentSummary.paymentAmount) > 0
                  && (!vendor.paymentSummary.payStatus
                    || vendor.paymentSummary.payStatus === PaymentStatus.REQUESTED.toString()
                    || vendor.paymentSummary.payStatus === PaymentStatus.RESENT_REQUEST.toString()
                    || vendor.paymentSummary.payStatus === PaymentStatus.REQUEST_REJECTED.toString()
                    || vendor.paymentSummary.payStatus === PaymentStatus.INVOICE_REJECTED.toString()))
                  .map(vendor => {
                    this.addEventVendor(event, vendor);
                  });
              });
            break;
          case BulkAction.CANCELLED:
            eventPage.content.filter(event =>
              !isNullOrUndefined(event.eventVendors))
              .map(event => {
                event.eventVendors.filter(vendor => !vendor.subscriber
                  && vendor.paymentSummary
                  && (!vendor.paymentSummary.payStatus
                    || vendor.paymentSummary.payStatus === PaymentStatus.REQUESTED.toString()
                    || vendor.paymentSummary.payStatus === PaymentStatus.RESENT_REQUEST.toString()
                    || vendor.paymentSummary.payStatus === PaymentStatus.REQUEST_REJECTED.toString()))
                  .map(vendor => {
                    this.addEventVendor(event, vendor);
                  });
              });
            break;
          }

          this.eventVendorSummaryList.sort(
            (vendorSummary1, avendorSummary2) => {
              if (vendorSummary1.name < avendorSummary2.name) {
                return -1;
              } else if (avendorSummary2.name > avendorSummary2.name) {
                return 1;
              } else {
                return 0;
              }
            });
        // Check number of events loaded
        if (!this.eventVendorSummaryList || this.eventVendorSummaryList.length === 0) {
          this.noEventsFound = true;
        } else {
          this.noEventsFound = false;
          this.eventCountForTranslate = {
            eventCount: this.eventVendorSummaryList.length
          };
        }

        // Uncheck all events
        this.allEventsChecked = false;
        this.checkUncheckAll();

        this.bulkActionModal.show();
      });
  }

  onCancel() {
    this.bulkActionModal.hide();
  }

  getEventNameLine1(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
    } else {
      return name;
    }
  }

  getEventNameLine2(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      const line2: string = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
      if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
        return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
      } else {
        return line2;
      }
    } else {
      return null;
    }
  }

  hasEventFinished(event: OnyxSummaryEvent) {
    return DateUtil.differenceInCalendarDays(DateUtil.parseDate(event.endDate), new Date()) < 0;
  }

  hasEventStarted(event: OnyxSummaryEvent) {
    return DateUtil.differenceInCalendarDays(DateUtil.parseDate(event.startDate), new Date()) < 0;
  }

  checkUncheckAll() {
    this.eventVendorSummaryList.forEach(event => {
      event.isSelected = this.allEventsChecked;
    });
    this.getCheckedItemList();
  }

  isAllSelected() {
    this.allEventsChecked = this.eventVendorSummaryList.every(item => {
      return item.isSelected === true;
    });
    this.getCheckedItemList();
  }

  getCheckedItemList() {
    this.selectedVendors = [];
    this.eventVendorSummaryList.forEach(event => {
      if (event.isSelected) {
        this.selectedVendors.push(event);
      }
    });
  }

  disableBulkActionButton() {
    return !this.selectedVendors || this.selectedVendors.length === 0;
  }

  confirmBeforeBulkActionHandler(value) {
    if (value) {
      this.onBulkAction();
    }
    this.bulkActionModal.show();
  }

  confirmBeforeBulkAction(): void {

    let label = '';
    switch ( this.bulkAction ) {
      case BulkAction.PAYMENT_REQUEST:
        label = 'EVENTS.BULK_ACTION.CONFIRM_PAYMENT_REQUEST';
        break;
      case BulkAction.PAID_DIRECT:
        label = 'EVENTS.BULK_ACTION.CONFIRM_PAID_DIRECT';
        break;
      case BulkAction.CANCELLED:
        label = 'EVENTS.BULK_ACTION.CONFIRM_CANCELLED';
        break;
      default:
        label = 'EVENTS.BULK_ACTION.CONFIRM_PAYMENT_REQUEST';
    }

    this.confirmationModalConfig.confirm = this.translateService.instant('EVENTS.BULK_ACTION.CONFIRM_PROCEED');
    this.confirmationModalConfig.title = this.translateService.instant(label, { eventCount: this.selectedVendors.length });
    this.bulkActionModal.hide();
    this.confirmationModal.open();
  }

  onBulkAction() {
    this.logService.info(JSON.stringify(this.selectedVendors));

    switch ( this.bulkAction ) {
      case BulkAction.PAYMENT_REQUEST:
        this.processPaymentRequests();
        break;

      case BulkAction.PAID_DIRECT:
        this.processPaidDirect();
        break;

      case BulkAction.CANCELLED:
        this.processCancelled();
        break;

    }
  }

  private processPaymentRequests() {
    let eventPayments: Payment[] = [];
    this.selectedVendors.forEach(vendor => {
      const payment = new Payment({
        commissionAmount: parseFloat(vendor.dueAmount.replace(/,/g, '')),
        description: '',
        commissionCurrency: vendor.currency,
        eventId: vendor.eventId,
        type: PaymentType.FINAL_PAYMENT,
        eventPartyId: vendor.eventPartyId
      });
      eventPayments.push(payment);
    });
    this.processPayments(eventPayments);
  }

  private processPaidDirect() {
    let eventPayments: Payment[] = [];
    this.selectedVendors.forEach(vendor => {
      const payment = new Payment({
        commissionAmount: parseFloat(vendor.paymentAmount.replace(/,/g, '')),
        description: '',
        commissionCurrency: vendor.currency,
        eventId: vendor.eventId,
        type: PaymentType.PAID_DIRECT,
        eventPartyId: vendor.eventPartyId
      });
      eventPayments.push(payment);
    });
    this.processPayments(eventPayments);
  }

  private processCancelled() {
    let eventPayments: Payment[] = [];
    this.selectedVendors.forEach(vendor => {
      const payment = new Payment({
        commissionAmount: null,
        description: '',
        commissionCurrency: vendor.currency,
        eventId: vendor.eventId,
        type: PaymentType.EVENT_CANCELLED,
        eventPartyId: vendor.eventPartyId
      });
      eventPayments.push(payment);
    });
    this.processPayments(eventPayments);
  }

  private processPayments(payments: Payment[]) {
    this.bulkActionInProcess = true;
    let failedPaymentCounter = 0;
    this.bulkActionInfo = this.translateService.instant('EVENTS.BULK_ACTION.PROCESSING', { paymentCount: payments.length });

    this.paymentStore.bulkActionPayments(payments)
      .subscribe(
        (res: BulkActionResponse[]) => {
          const failedPayments = res.filter(r => r.error);
          failedPaymentCounter = failedPayments.length;
          // Retrieve failures
          if (failedPaymentCounter > 0) {
            this.bulkActionInfo = this.translateService
              .instant('EVENTS.BULK_ACTION.FAILURES', { failedPaymentCount: failedPayments.length, paymentCount: payments.length });
            failedPayments.forEach(r => {
                let vendor = this.selectedVendors.find(v => v.eventPartyId === r.eventPartyId);
                this.bulkActionInfo += this.translateService
                  .instant('EVENTS.BULK_ACTION.PAYMENT_ERROR',
                    { eventReferenceNumber: vendor.eventReferenceNumber, vendorName: vendor.vendorName, error: r.error });
            });

            this.logService.info(this.bulkActionInfo);
          }
          this.flashMessagesService.success('EVENT.COMMISSION.PAYMENTS_SAVED');
          },
        (err) => {
              this.logService.error(`Error processing Bulk Payments: ${err}`);
              if (typeof err === 'string' && err.includes('The provided bulk payments are greater than')) {
                this.flashMessagesService.error('EVENTS.BULK_ACTION.MAX_NUMBER_PAYMENTS', `Error processing Payment: ${err}`);
              } else {
                this.flashMessagesService.error('EVENTS.BULK_ACTION.ERROR', `Error processing Payment: ${err}`);
              }
          },
        () => {
          this.logService.info('Bulk Payments completed');
          if (failedPaymentCounter === 0) {
            this.bulkActionModal.hide();
          }
          this.refreshEvents.emit(true);
          }
      );
  }

  private addEventVendor(event: OnyxSummaryEvent, vendor: Party): void {

    let eventVendor = new EventVendorSummary();

        eventVendor.eventId = event.eventId,
        eventVendor.name = event.name,
        eventVendor.startDate = event.startDate,
        eventVendor.endDate = event.endDate,
        eventVendor.autoGenerated = event.autoGenerated,
        eventVendor.eventReferenceNumber = event.eventReferenceNumber,
        eventVendor.eventPartyId = vendor.eventPartyId,
        eventVendor.vendorName = vendor.name,
        eventVendor.masterBillPaid = vendor.masterBillPaid,
        eventVendor.currency = event.currency,
        eventVendor.dueAmount = this.decimalPipe.transform(vendor.paymentSummary.dueAmount, '1.2-2'),
        eventVendor.paymentAmount = this.decimalPipe.transform(vendor.paymentSummary.dueAmount, '1.2-2'),
        eventVendor.payStatus = vendor.paymentSummary.payStatus

    ;
    this.eventVendorSummaryList.push(eventVendor);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/bulk-action/bulk-action-popup/bulk-action-popup.component.ts